import "./index.scss";

import PlusSquare from "assets/img/svg/plusSquare";
import ShareArrowUp from "assets/img/svg/shareArrowUp";
import ModalBox from "components/Modal";
import StyledButton from "components/shared/StyledButton";
import { useTranslation } from "react-i18next";
const logoCrealo = "/logoCrealo.png";

interface IInstallCrealoAppModal {
    open: boolean;
    close: VoidFunction;
}

const InstallCrealoAppModal = ({ open, close }: IInstallCrealoAppModal) => {
    const [t] = useTranslation();

    return (
        <ModalBox open={open} onClose={close} mainTitle={t("BPSettings.InstallCrealoApp")}>
            <div className="install-crealo-app">
                <div className="install-crealo-app-header">
                    <img src={logoCrealo} />
                    <div className="text-wrapper">
                        <span className="title">{t("BPSettings.CrealoWebApp")}</span>
                        <span className="subtitle">{t("BPSettings.CrealoRoyalties")}</span>
                    </div>
                </div>
                <span className="install-crealo-app-subtext">{t("BPSettings.EnjoyCrealoSpace")}</span>
                <div className="install-crealo-app-steps">
                    <div className="steps">
                        <div className="number-icon">1</div>
                        <div className="step-text-wrapper">
                            {t("BPSettings.TouchIcon")}
                            <ShareArrowUp height="16" width="16" />
                            {t("BPSettings.ScreenBottom")}
                        </div>
                    </div>
                    <div className="steps">
                        <div className="number-icon">2</div>
                        <div className="step-text-wrapper">
                            {t("BPSettings.SelectHomeScreen")}
                            <PlusSquare height="16" width="16" />
                        </div>
                    </div>
                    <div className="steps">
                        <div className="number-icon">3</div>
                        {t("BPSettings.PressAddToConfirm")}
                    </div>
                </div>
                <StyledButton buttonType="primary" onClick={close}>
                    {t("BPSettings.CrealoAppInstalled")}
                </StyledButton>
            </div>
        </ModalBox>
    );
};

export default InstallCrealoAppModal;
